module.exports = __webpack_public_path__ + "static/media/bez-izgovori.ad4a21bd.png";